export * from "./addon.metadata";
export * from "./administration.metadata";
export * from "./extension.metadata";
export * from "./extension-shell.metadata";
export * from "./injection.metadata";
export * from "./module.metadata";
export * from "./page.metadata";
export * from "./page-form.metadata";
export * from "./page-schema.metadata";
